module.exports = __webpack_public_path__ + "static/media/office.8dce9bc2.png";